import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const SosaiHohoKbn = props => {
  return <Dropdown.Static kubunKey='sosai_hoho_kbn' {...props} />
}
